module.exports = __webpack_public_path__ + "img/button_bg.b1c926ee.png";